import { render, staticRenderFns } from "./pubcase.vue?vue&type=template&id=8d09d360&scoped=true"
import script from "./pubcase.vue?vue&type=script&lang=js"
export * from "./pubcase.vue?vue&type=script&lang=js"
import style0 from "./pubcase.vue?vue&type=style&index=0&id=8d09d360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d09d360",
  null
  
)

export default component.exports